import { AnimatePresence, motion } from 'framer-motion';
import { parse } from 'path/posix';
import { useEffect, useState } from 'react';

interface TextSwitcherProps {
	textList: string[];
	interval: number;
}
const TextSwitcher: React.FunctionComponent<TextSwitcherProps> = (props) => {
	const { textList, interval } = props;
	const [activeIndex, setActiveIndex] = useState(0);
	const [time, setTime] = useState(Date.now());
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		const _interval = setInterval(() => setTime(Date.now()), interval);
		return () => {
			clearInterval(_interval);
		};
	}, []);

	useEffect(() => {
		let nextActiveIndex = activeIndex + 1;
		if (nextActiveIndex >= textList.length) nextActiveIndex = 0;
		setActiveIndex(nextActiveIndex);
	}, [time]);

	useEffect(() => {
		const animationDuration = interval - 1000;
		const _interval = setInterval(() => setAnimate(true), animationDuration);
		return () => {
			clearInterval(_interval);
			setAnimate(false);
		};
	}, [activeIndex]);

	const animationSentence = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				delay: 0.5,
				staggerChildren: 0.08,
			},
		},
	};

	return (
		<div className="flex flex-col">
			<div className="md:px-6 mx-auto relative">
				<motion.div
					className="flex flex-col space-y-3 justify-center w-40 md:w-52 mx-auto relative mt-3"
					variants={animationSentence}
					initial="hidden"
					animate="visible"
					exit="hidden"
				>
					<span className="font-medium pt-1 italic text-6xl md:text-7xl mr-3">
						{textList[activeIndex].split('').map((char, index) => {
							return (
								<motion.span
									key={time + '-' + index}
									variants={{
										hidden: { opacity: 0, y: 50 },
										visible: { opacity: 1, y: 0, transition: { delay: index * 0.1 } },
										exit: {
											opacity: 0,
											y: 50,
											transition: { delay: (textList[activeIndex].length - index) * 0.1 },
										},
									}}
								>
									{char}
								</motion.span>
							);
						})}
					</span>
				</motion.div>
				{/* <motion.div
					animate={animate ? { x: 0 } : { x: '200%' }}
					transition={{ duration: 1 }}
					className="w-full h-full bg-blue-500 absolute top-0 left-0"
				></motion.div> */}
			</div>
			<div className="h-0.5 bg-black mx-auto w-64 md:w-72" />
		</div>
	);
};

export default TextSwitcher;

// import { motion } from 'framer-motion';
// import { useEffect, useState } from 'react';

// interface TextSwitcherProps {
// 	textList: string[];
// 	interval: number;
// }
// const TextSwitcher: React.FunctionComponent<TextSwitcherProps> = (props) => {
// 	const { textList, interval } = props;
// 	const [activeIndex, setActiveIndex] = useState(0);
// 	const [time, setTime] = useState(Date.now());
// 	const [animate, setAnimate] = useState(false);

// 	useEffect(() => {
// 		const _interval = setInterval(() => setTime(Date.now()), interval);
// 		return () => {
// 			clearInterval(_interval);
// 		};
// 	}, []);

// 	useEffect(() => {
// 		let nextActiveIndex = activeIndex + 1;
// 		if (nextActiveIndex >= textList.length) nextActiveIndex = 0;
// 		setActiveIndex(nextActiveIndex);
// 	}, [time]);

// 	useEffect(() => {
// 		const animationDuration = interval - 1000;
// 		const _interval = setInterval(() => setAnimate(true), animationDuration);
// 		return () => {
// 			clearInterval(_interval);
// 			setAnimate(false);
// 		};
// 	}, [activeIndex]);

// 	return (
// 		<div className="flex flex-col">
// 			<div className="md:px-6 mx-auto relative">
// 				<div className="flex flex-col space-y-3 justify-center w-40 md:w-52 mx-auto relative mt-3">
// 					<span className="font-medium pt-1 italic text-6xl md:text-7xl mr-3">{textList[activeIndex]}</span>
// 				</div>
// 				<motion.div
// 					animate={animate ? { x: 0 } : { x: '200%' }}
// 					transition={{ duration: 1 }}
// 					className="w-full h-full bg-blue-500 absolute top-0 left-0"
// 				></motion.div>
// 			</div>
// 			<div className="h-0.5 bg-black mx-auto w-64 md:w-72" />
// 		</div>
// 	);
// };

// export default TextSwitcher;
